import { Fragment } from "react";
import { getState } from "../../library/dataService.ts";
import { useSync } from "../../library/syncData";
import NGSyncOverlay from "../../generators/NGSyncOverlay.tsx";
import NGUserContainer from "../../generators/NGUserContainer.tsx";

export default function NGSync({ config, context }) {
  const { state } = getState(context);
  const user = state.User.value;

  if (user) {
    const { ThemeMode, EnableSyncMode } = user.Details;
    if (EnableSyncMode) {
      const { Users, SyncId, OverlayCollection } = useSync(config, context);
      return (
        <>
          <NGSyncOverlay Users={Users} SyncId={SyncId} OverlayCollection={OverlayCollection} />
          <NGUserContainer Users={Users} ThemeMode={ThemeMode} />
        </>
      );
    }
  }
  return null;
}
